/* 新媒体项目详情 */
export const newMedia = `query newMedia($id: ID! = 1){
  newMedia(id: $id){
    id
    ObjectName
    objectSubtitle
    objectIntroduction
    about
    bannerColor
    isPublish
    router
    videoUrl
    videoDesc
    videoBackground{
      url
    }
    botImg{
      url
    }
    bannerImg{
      url
    }
    logo{
      url
    }
    bannerBotLab{
      id
      lab
      num
      icon{
        url
      }
    }
    StudentWorksTitle
    StudentWorksEnTitle
    StudentWorksBgColor
    StudentWorksSubTitle
    BgImg{
      url
    }
    studentWorks{
      title
      subTitle
      url
      imgUrl{
        url
      }
      labName
      image{
        url
      }
      labTree{
        title
        subTitle
        desc
      }
    }
    publicModule{
      id
      title
      subTitle
      bgColor
      EnTitle
      bgImage{
        url
      }
      image{
        url
      }
    }
    abilityTitle
    abilityEntitle
    abilityLists{
      about
      title
      image{
        url
      }
    }
    classTitle
    classEntitle
    classBgColor
    classBgImg{
      url
    }
    classLists{
      id
      title
      about
      image{
        url
      }
    }
  }
}`